import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=05eb05e8"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=05eb05e8&lang=sass&scope=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05eb05e8')) {
      api.createRecord('05eb05e8', component.options)
    } else {
      api.reload('05eb05e8', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=05eb05e8", function () {
      api.rerender('05eb05e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NotFound.vue"
export default component.exports